/* eslint-disable no-irregular-whitespace */
import React from 'react';
import Calendar from 'react-calendar';

const DateSelect = ({ selectedDate, handleDateClick, maximumBookingDays = 30 }) => {
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + Number(maximumBookingDays || 30));

  return (
    <>
      <h4 className="margin-bottom--sm">Select your preferred meeting time.</h4>
      <Calendar
        value={selectedDate}
        onClickDay={handleDateClick}
        minDate={new Date()}
        maxDate={maxDate}
        calendarType="gregory"
        // tileDisabled={tileDisabled}
      />
      <style jsx>
        {`
          h4 {
            color: black;
          }
        `}
      </style>
    </>
  );
};

export default DateSelect;
